export default {
  order: 6,
  layerGroupId: 'GROUP_CLIMATE',
  dataLayer: {
    id: 'FOREST_CARBON_GROSS_REMOVALS',
    order: 6,
    type: 'remoteDataLayer',
    uuid: '79010c83-e62e-4744-96ed-130736daa651',
    groupId: 'GROUP_CLIMATE',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        name: {
          en: 'Forest carbon gross removals (2001-2024)',
          fr: 'Retraits bruts de carbone en forêt',
          es: 'Extracciones brutas de carbono en bosques',
          pt: 'Remoções brutas de carbono florestal',
          id: 'Penghapusan bruto karbon hutan',
          zh: '森林碳总去除量',
          ka: 'Орман карбондық жалпы шығындар',
        },
        type: 'gradient',
        items: [
          {
            color: 'rgb(28, 68, 91)',
            name: {
              en: '>1500 tCO₂e ha⁻¹',
              fr: '>1500 tCO₂e ha⁻¹',
              es: '>1500 tCO₂e ha⁻¹',
              pt: '>1500 tCO₂e ha⁻¹',
              id: '>1500 tCO₂e ha⁻¹',
              zh: '>1500 tCO₂e ha⁻¹',
              ka: '>1500 tCO₂e ha⁻¹',
            },
          },
          {
            color: 'rgb(17, 122, 120)',
            name: {
              en: '',
              fr: '',
              es: '',
              pt: '',
              id: '',
              zh: '',
              ka: '',
            },
          },
          {
            color: 'rgb(209, 216, 197)',
            name: {
              en: '',
              fr: '',
              es: '',
              pt: '',
              id: '',
              zh: '',
              ka: '',
            },
          },
          {
            color: 'rgb(221, 224, 209)',
            name: {
              en: '',
              fr: '',
              es: '',
              pt: '',
              id: '',
              zh: '',
              ka: '',
            },
          },
          {
            color: 'rgb(255, 246, 244)',
            name: {
              en: '0',
              fr: '0',
              es: '0',
              pt: '0',
              id: '0',
              zh: '0',
              ka: '0',
            },
          },
        ],
      },
      interactionConfig: {},
    },
    id: 'FOREST_CARBON_GROSS_REMOVALS',
    type: 'forest-carbon-gross-removals',
    url: 'https://tiles.globalforestwatch.org/gfw_forest_carbon_gross_removals/v20250416/tcd_30/{z}/{x}/{y}.png',
    technicalName: 'wri_forest_carbon_gross_removals',
    label: {
      en: 'Forest carbon gross removals',
      fr: 'Retraits bruts de carbone en forêt',
      es: 'Extracciones brutas de carbono en bosques',
      pt: 'Remoções brutas de carbono florestal',
      id: 'Penghapusan bruto karbon hutan',
      zh: '森林碳总去除量',
      ka: 'Орман карбондық жалпы шығындар',
    },
    sublabel: {
      en: '30m, global, 2001-2024, Harris et al. 2024',
      fr: '30m, global, 2001-2024, Harris et al. 2024',
      es: '30m, global, 2001-2024, Harris et al. 2024',
      pt: '30m, global, 2001-2024, Harris et al. 2024',
      id: '30m, global, 2001-2024, Harris et al. 2024',
      zh: '30m, global, 2001-2024, Harris et al. 2024',
      ka: '30m, global, 2001-2024, Harris et al. 2024',
    },
  },
  isMetadataError: false,
  isError: false,
};
